package dev.lingvo.ops.state

fun auditFilterSummary(actor: String?, action: String?, shown: Int): String = buildString {
    append("Showing ").append(shown).append(" events")
    actor?.takeIf(String::isNotBlank)?.let { append(" for actor ").append(it) }
    action?.takeIf(String::isNotBlank)?.let { append(" with action ").append(it) }
    append(".")
}
